import { render, staticRenderFns } from "./Seo1.vue?vue&type=template&id=265847e4&scoped=true&"
import script from "./Seo1.vue?vue&type=script&lang=js&"
export * from "./Seo1.vue?vue&type=script&lang=js&"
import style0 from "./Seo1.vue?vue&type=style&index=0&id=265847e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265847e4",
  null
  
)

export default component.exports